import { RouteObject } from "react-router-dom"
import ChangePasswordPage from "../page/change-password"
import ForgotPasswordPage from "../page/forgot-password-page"
import UpdatePasswordPage from "../page/update-password"

export const AccountRoute: RouteObject = {
  path: "/accounts/forget-password",
  element: <ForgotPasswordPage />,
}
export const ChangePasswordRoute: RouteObject = {
  path: "/accounts/change-password",
  element: <ChangePasswordPage />,
}
export const UpdatePasswordRoute: RouteObject = {
  path: "/accounts/update-password",
  element: <UpdatePasswordPage />,
}
